import React from 'react';
import { VoucherIcon } from '../../../../components/icons';
import { formatThousands } from '../../../../utils';
import { Container } from './styles';

type Props = {
    available: number;
    index: number;
}

const ExhibitorBalance: React.FC<Props> = ({ available, index }) => {
    return (
        <Container>
            <VoucherIcon />
            <span>{formatThousands(available)}</span>
            <label>cortesias totais</label>
        </Container>
    );
};

export { ExhibitorBalance };
